import { Box, makeStyles } from "@material-ui/core";
import React from "react";

import { ManagementAppBar } from "@/components/property/AppBar";
import { PublicHeader } from "@/components/PublicHeader";
import { useDevice } from "@/hooks/useDevice";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: {
    minHeight: "100vh",
    backgroundColor: theme.palette.semantic["surface/card"],
    [theme.breakpoints.up("md")]: { backgroundColor: theme.palette.semantic["surface/base"] },
  },
  header: { display: "none", [theme.breakpoints.up("md")]: { display: "block" } },
  card: {
    width: "100%",
    padding: "32px 24px 64px",
    margin: "0 auto",
    [theme.breakpoints.up("md")]: {
      width: 560,
      padding: "40px 48px",
      borderRadius: 16,
      backgroundColor: theme.palette.semantic["surface/card"],
      margin: "48px auto 64px",
    },
  },
  result: {
    width: "100%",
    backgroundColor: theme.palette.semantic["surface/base"],
    paddingBottom: 64,
    [theme.breakpoints.up("md")]: { width: 720, margin: "48px auto 0" },
  },
  full: { width: "100%", paddingBottom: 64, backgroundColor: theme.palette.semantic["surface/base"] },
  phases: { marginBottom: 24 },
}));

/** 診断だけの枠。SPはヘッダーなし、PCは通常のナビと画面種別に応じた幅を使う。 */
export const DiagnosisLayout: React.FC<{
  children: React.ReactNode;
  phaseTags?: React.ReactNode;
  mode?: "card" | "result" | "full";
  publicHeader?: boolean;
}> = ({ children, phaseTags, mode = "card", publicHeader = false }) => {
  const classes = useStyles();
  const { isMobile } = useDevice();
  return (
    <Box className={classes.root}>
      {!isMobile && <Box className={classes.header}>{publicHeader ? <PublicHeader /> : <ManagementAppBar />}</Box>}
      <Box component="main" className={classes[mode]}>
        {phaseTags && <Box className={classes.phases}>{phaseTags}</Box>}
        {children}
      </Box>
    </Box>
  );
};

export const diagnosisActionStyles = {
  width: "100%",
  margin: "32px auto 0",
  [theme.breakpoints.up("md")]: { maxWidth: 360 },
};
